import { useTheme } from '@/hooks/useTheme';
import { IconMoon, IconSun } from '@/components/home/icons';

export function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const isDark = theme === 'dark';
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      title={isDark ? 'Light theme' : 'Dark theme'}
      className="inline-flex h-9 w-9 items-center justify-center rounded-lg text-night-200 transition-colors hover:bg-night-700/60 hover:text-night-50"
    >
      {isDark ? <IconSun className="h-5 w-5" /> : <IconMoon className="h-5 w-5" />}
    </button>
  );
}
